import { ReactNode } from "react";

export interface CellActionsProps {
  children: ReactNode;
  className?: string;
}

export const CellActions = ({ children, className = "" }: CellActionsProps) => (
  <div
    className={`absolute right-2 top-2 z-[9999] flex gap-1 opacity-0 transition-opacity duration-200 group-hover/Cell:opacity-100 ${className}`}
  >
    {children}
  </div>
);
